export const appIcons = [
  "icon-01",
  "icon-02",
  "icon-03",
  "icon-04",
  "icon-05",
  "icon-06",
  "icon-07",
  "icon-08",
  "icon-09",
  "icon-10",
  "icon-11",
  "icon-12",
  "icon-13",
  "icon-14",
  "icon-15",
  "icon-16",
  "icon-17",
  "icon-18",
  "icon-19",
  "icon-20",
  "icon-21",
  "icon-22",
  "icon-23",
  "icon-24",
  "icon-25",
  "icon-26",
  "icon-27",
  "icon-28",
  "icon-29",
  "icon-30",
  "icon-31",
  "icon-32",
  "icon-33",
  "icon-34",
  "icon-35",
  "icon-36",
  "icon-37",
  "icon-38",
  "icon-39",
  "icon-40"
]
export const appColors = ["#1989FA", "#9A59FF", "#FD6565", "#40D492", "#FDA23F"]

export const RobotTableColumns = [
  {
    label: "机器人名称",
    value: "name"
  },
  {
    label: "机器人Token",
    value: "dingRobotToken"
  },
  {
    label: "机器人秘钥",
    value: "dingRobotSecret"
  }
]
